import { collectOrgIdsForAnyOrgPermission, requireAnySystemPermission, } from '@juvare/contact-management/backend/features/permissions/shared';
import { AuthError } from '@juvare/platform-app/App';
import { implementTypedPlatformFunction } from '@juvare/platform-sdk-react/backend/features/typed-platform-functions';
import { accountBadgeEntityName } from '../entities/AccountBadgeEntityTypes';
import { badgeEntityName } from '../entities/BadgeEntityTypes';
import { getAccountBadgeFiltersByStatus } from '../utils/getAccountBadgeFiltersByStatus';
import { getBadgesWithAnalyticsFunctionDef, } from './getBadgesWithAnalyticsSchema';
export const getBadgesWithAnalyticsFunctionImpl = implementTypedPlatformFunction(getBadgesWithAnalyticsFunctionDef, getBadgesWithAnalytics);
export function getBadgesWithAnalytics(context, req) {
    const badgeStorage = context.storage(badgeEntityName);
    const accountBadgeStorage = context.storage(accountBadgeEntityName);
    if (!requireAnySystemPermission(context.userState, 'manage-badges', 'manage-account-badges')) {
        throw new AuthError('Unauthorized');
    }
    const filter = [];
    if (!requireAnySystemPermission(context.userState, 'all-organizations-admin', 'manage-organizations')) {
        const organizationIdsWhereAccountIsAdmin = collectOrgIdsForAnyOrgPermission(context.userState, 'manage-members');
        filter.push({
            op: 'or',
            filter: [
                {
                    op: 'overlap',
                    column: 'organizationIds',
                    value: organizationIdsWhereAccountIsAdmin,
                },
                {
                    op: '=',
                    column: 'organizationIds',
                    value: [],
                },
            ],
        });
    }
    const badges = badgeStorage.list({
        limit: req.limit,
        offset: req.offset,
        filter,
        orderByUpdatedDesc: true,
    });
    const badgesWithAnalytics = badges.rows.map((row) => {
        var _a;
        const validAccountBadges = accountBadgeStorage.count({
            filter: getAccountBadgeFiltersByStatus(row.id, 'valid'),
        });
        const invalidAccountBadges = accountBadgeStorage.count({
            filter: getAccountBadgeFiltersByStatus(row.id, 'valid', '!='),
        });
        const badgeData = badgeStorage.get(row.id);
        return {
            id: row.id,
            name: row.columns.name,
            description: row.columns.description,
            expirationIntervalMonths: badgeData.data.expirationIntervalMonths,
            organizationIds: (_a = badgeData.data.organizationIds) !== null && _a !== void 0 ? _a : [],
            validAccountBadgesCount: validAccountBadges,
            invalidAccountBadgesCount: invalidAccountBadges,
        };
    });
    return {
        total: badges.total,
        rows: badgesWithAnalytics,
    };
}
